/*
 * SSR 불가능한 코드입니다. 추후 next로 마이그레이션 하게 됐을때 수정해야합니다.
 */
// Mozilla/5.0 (SMART-TV; LINUX; Tizen 6.5) AppleWebKit/537.36 (KHTML, like Gecko) 85.0.4183.93/6.5 TV Safari/537.36
export const isSmartTv = navigator.userAgent.indexOf('Tizen') > -1;

if (!isSmartTv && process.env.REACT_APP_ENV === 'production') {
  window.history.back();
}
